/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql, StaticQuery, Script } from "gatsby";
import parse from "html-react-parser";
import GeneralFilters from "./general-filters";
import JobOpenings from "./jobOpenings";
import MarketoForm from "./marketo";
import { replaceLinks } from "../utils/replace-urls";
const options = {
  replace: (domNode, index) => {
    const generalFilters =
      domNode?.attribs?.["data-general-filters"] === "true";

    if (generalFilters) {
      return <GeneralFilters attribs={domNode?.attribs} />;
    }
    const formId = domNode?.attribs?.["data-form-id"];

    const thankyouHeading = domNode?.attribs?.["data-thank-you-heading"];
    const thankyouButtonText = domNode?.attribs?.["data-thank-you-button-text"];
    const resourceURL = domNode?.attribs?.["data-resource-url"];

    const jobOpenings = domNode?.attribs?.["data-job-openings"];

    if (jobOpenings) {
      return <JobOpenings />;
    }

    if (formId) {
      return (
        <MarketoForm
          formId={formId}
          thankyouHeading={thankyouHeading}
          thankyouButtonText={thankyouButtonText}
          resourceURL={resourceURL}
        />
      );
    }

    if (domNode?.name === "a" && domNode?.attribs?.href) {
      const src = domNode?.attribs?.href;
      const extension = src.split(".").pop();
      if (src.startsWith("/") && extension === "pdf") {
        domNode.attribs.href = `${process.env.GATSBY_WP_BASE_PAGES}${src}`;
      } else {
        domNode.attribs.href = replaceLinks(domNode?.attribs?.href);
      }
    }

    if (domNode?.name === "img" && domNode?.attribs?.src) {
      const src = domNode?.attribs?.src;
      if (src.startsWith("/")) {
        // Tmp fix for images GATSBY_GATSBY_WP_BASE_PAGES is not defined in netlify env variables not sure if it needs to be different
        domNode.attribs.src = `${process.env.GATSBY_WP_BASE_PAGES}${src}`;
        // domNode.attribs.src = `${process.env.GATSBY_GATSBY_WP_BASE_PAGES}${src}`;
      }
    }

    return domNode;
  },
};
const Footer = ({ children }) => {
  return (
    <StaticQuery
      query={graphql`
        query FooterQuery {
          wpPages {
            footer
          }
        }
      `}
      render={(data) => parse(data.wpPages.footer, options)}
    />
  );
};

Footer.propTypes = {
  children: PropTypes.node,
};

export default Footer;
